<!--
Copyright 2025 Google LLC. This software is provided as-is, without warranty 
or representation for any use or purpose. Your use of it is subject to your 
agreement with Google.
-->
<div class="user-message">
    <span class="user-logo">
        <img src="../../assets/user-icon.png" alt="user-icon" class="user-icon">
    </span>
    <span class="user-question">{{userQuestion}}</span>
</div>

<app-respond [botMsg]="botResponse" [botError]="botError" (updateCitationVal)="onSelectedCitation($event)"
    [batchPreviewResponse]="batchPreviewResponse" [batchPreviewError]="batchPreviewError" (isPreviousCitationHighlighted)="isCitationHighlighted($event)" (isSorryContext)="hideFuqs($event)">
</app-respond>
<app-fuq [FUQResponse]="FUQResponse" *ngIf="!botError && botResponse && !hideFuq" [FUQError]="FUQError" (question)="onFuqQuestionClick($event)">
</app-fuq>
<div #scrollToHere>
</div>